import React, { useState } from "react";
import style from "./edit.module.css";
import Button from "@material-ui/core/Button";
import axios from "axios";
import { BlogCard } from "./BlogCard";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export const Editblog = () => {
  const [posts, setPosts] = useState([]);
  const [editor, setEditor] = useState(false);
  const [creador, setCreador] = useState(false);
  const [edit, setEdit] = useState({
    title: "",
    _id: "",
    texto: "",
    autor: "",
    img: "test",
  });

  const [creacion, setCreacion] = useState({
    title: "",
    texto: "",
    autor: "",
    img: "test",
  });

  const [valid, setValid] = useState(false);

  const test2 = (e) => {
    console.log(edit);
  };

  const titleHandler = (e) => {
    setEdit({
      ...edit,
      title: e.currentTarget.value,
    });
  };

  const textoHandler = (data) => {
    setEdit({
      ...edit,
      texto: data,
    });
  };

  const autorHandler = (e) => {
    setEdit({
      ...edit,
      autor: e.currentTarget.value,
    });
  };

  const UpdateCont = () => {
    axios
      .post("https://iluminarte3.herokuapp.com/updatecont", edit)
      .then((response) => {
        if (response.status === 200) setEditor(false), search();
      });

    document.getElementById("updForm").reset();

    return;
  };

  const titleCreator = (e) => {
    setCreacion({
      ...creacion,
      title: e.currentTarget.value,
    });
  };

  const textoCreator = (e) => {
    setCreacion({
      ...creacion,
      texto: e.currentTarget.value,
    });
  };

  const autorCreator = (e) => {
    setCreacion({
      ...creacion,
      autor: e.currentTarget.value,
    });
  };

  const search = () => {
    axios.get(`https://iluminarte3.herokuapp.com/cont`).then((res) => {
      setPosts(res.data);
    });
    setCreador(false);
  };

  const openCreate = () => {
    setEditor(false), setPosts([]);
    setCreador(true);
    setUpdate({ title: "", _id: "", texto: "", autor: "", img: "test" });

    return;
  };

  const CreatePost = () => {
    setEditor(false), setPosts([]);
    setCreador(true);
    setUpdate({ title: "", _id: "", texto: "", autor: "", img: "test" });

    axios.post("https://iluminarte3.herokuapp.com/createcont", creacion);

    document.getElementById("miForm").reset();
    return;
  };

  const DeletePost = (e) => {
    console.log(typeof e.currentTarget.value);

    axios
      .delete(
        "https://iluminarte3.herokuapp.com/cont/delete/" + e.currentTarget.value
      )
      .then(search, setValid(false));
  };

  const confirmation = () => {
    setValid(true);
  };

  const testPubl = (post) => {
    setEditor(false);

    setEdit({
      title: post.title,
      _id: post._id,
      texto: post.texto,
      autor: post.autor,
      img: "test",
    });

    setTimeout(() => {
      setEditor(true);
    }, 20);

    setCreador(false);
    setCreacion({ title: "", texto: "", autor: "", img: "test" });
  };

  return (
    <div className={style.container}>
      <div className={style.nav}>
        <Button
          variant="contained"
          color="primary"
          onClick={openCreate}
          className={style.btn2}
        >
          Crear Publicaciones
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={search}
          className={style.btn2}
        >
          Editar Publicaciones
        </Button>
      </div>

      <div className={style.postCont}>
        {posts.length > 0
          ? posts.map((post) => (
              <div className={style.cardCont}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={confirmation}
                  className={style.btnRed}
                >
                  X
                </Button>
                {valid ? (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={DeletePost}
                    className={style.btnRed}
                    value={post._id}
                  >
                    Eliminar
                  </Button>
                ) : (
                  ""
                )}

                <BlogCard
                  title={post.title}
                  texto={post.texto}
                  autor={post.autor}
                  id={post._id}
                ></BlogCard>
                <Button
                  variant="contained"
                  color="primary"
                  className={style.btn}
                  value={post}
                  onClick={() => testPubl(post)}
                >
                  Editar
                </Button>
              </div>
            ))
          : ""}
      </div>

      {editor ? (
        <form id="updForm" className={style.editor}>
          <label for="titulo" className={style.label}>
            Titulo
          </label>
          <input
            type="text"
            defaultValue={edit.title}
            id="titulo"
            required
            onChange={titleHandler}
            className={style.input}
          />

          <label for="texto" className={style.label}>
            Texto
          </label>
          <CKEditor
            editor={ClassicEditor}
            data={edit.texto}
            onReady={(editor) => {
              // You can store the "editor" and use when it is needed.
              console.log("Editor is ready to use!", editor);
            }}
            onChange={(event, editor) => {
              const data = editor.getData();

              textoHandler(data);
            }}
            onBlur={(event, editor) => {}}
            onFocus={(event, editor) => {}}
          />

          <label for="autor" className={style.label}>
            Autor
          </label>
          <input
            type="text"
            id="autor"
            required
            defaultValue={edit.autor}
            onChange={autorHandler}
            className={style.input}
          />
          <Button
            variant="contained"
            color="primary"
            className={style.btn2}
            onClick={UpdateCont}
          >
            Actualizar Publicacion
          </Button>

          <Button
            variant="contained"
            color="primary"
            className={style.btn2}
            onClick={test2}
          >
            TEST
          </Button>
        </form>
      ) : (
        ""
      )}

      {creador ? (
        <form id="miForm" className={style.editor}>
          <label for="titulo" className={style.label}>
            Titulo
          </label>
          <input
            type="text"
            id="titulo"
            required
            onChange={titleCreator}
            className={style.input}
          />

          <label className={style.label} for="texto">
            Texto
          </label>
          <textarea
            type="text"
            id="texto"
            rows="6"
            cols="33"
            onChange={textoCreator}
            required
            className={style.input}
          />

          <label className={style.label} for="autor">
            Autor
          </label>
          <input
            type="text"
            id="autor"
            required
            onChange={autorCreator}
            className={style.input}
          />
          <div>
            {" "}
            <Button
              variant="contained"
              color="primary"
              className={style.btn2}
              onClick={CreatePost}
            >
              Crear Publicacion
            </Button>
          </div>
        </form>
      ) : (
        ""
      )}
    </div>
  );
};
